import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const AutoserviceMenu = lazy(() => import('src/pages/autoservice/autoservice-menu'));
const AutoserviceCheckout = lazy(() => import('src/pages/autoservice/autoservice-checkout'));
const AutoserviceSuccess = lazy(() => import('src/pages/autoservice/autoservice-success'));

// ----------------------------------------------------------------------

const autoservice = {
  path: 'autoservice',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: ':uuid',
      element: (
        <GuestGuard>
            <AutoserviceMenu />
        </GuestGuard>
      ),
    },
    {
      path: ':uuid/checkout',
      element: (
        <GuestGuard>
            <AutoserviceCheckout />
        </GuestGuard>
      ),
    },
    {
      path: ':uuid/success',
      element: (
        <GuestGuard>
            <AutoserviceSuccess />
        </GuestGuard>
      ),
    },
  ],
};

export const autoserviceRoutes = [
  {
    path: '/',
    children: [autoservice],
  },
];
